/* import __COLOCATED_TEMPLATE__ from './staff-premium-upsell-check-row.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();